import { Box } from '@mui/material';
import useIsUserPremium from '@/DesignSystem/hooks/useIsUserPremium';
import useIsProduction from '@/DesignSystem/hooks/useIsProduction';
import { hbAdComponents, HbAdType } from '../hb-agency/hb-ad';

const Placement1Component = () => {
    const isPremium = useIsUserPremium();
    const isProduction = useIsProduction();

    if (isPremium || !isProduction) return null;

    return <Box className="placement-ad-template">{hbAdComponents[HbAdType.MOBILE_DESKTOP_LEADERBOARD]}</Box>;
};

export default Placement1Component;
